module.exports = __webpack_public_path__ + "img/xwqyrzsq.293c9e38.png";